import React, { CSSProperties } from 'react';

interface DropdownMenuItem {
  text: string;
}

interface DropdownMenuProps {
  title: string;
  items: DropdownMenuItem[];
  selectedItemText?: string;
  onItemSelect?: (itemText: string) => void;
  className?: string;
}

const styles: { [key: string]: CSSProperties } = {
  container: {
    display: 'flex',
    // width: '983px',
    padding: '12px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '12px',
    borderRadius: '0 0 8px 8px',
    borderTop: '1px solid #E5E5E5',
    background: '#FFF',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch'
  },
  titleText: {
    color: '#737373',
    fontFamily: 'Inter, sans-serif',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '16px'
  },
  itemsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    alignSelf: 'stretch'
  },
  menuItem: {
    display: 'flex',
    padding: '6px 0',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '6px',
    cursor: 'pointer'
  },
  radioButton: {
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    border: '1px solid #E5E5E5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: '#FFF',
  },
  radioButtonSelected: {
    width: '20px',
    height: '20px',
    borderRadius: '9999px',
    border: '1px solid #E5E5E5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    background: '#FFF',
  },
  radioInner: {
    width: '8px',
    height: '8px',
    borderRadius: '9999px',
    backgroundColor: '#3B82F6',
    flexShrink: 0,
    aspectRatio: '1/1'
  },
  itemText: {
    color: '#0A0A0A',
    fontFamily: 'Inter, sans-serif',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '28px',
    display: '-webkit-box',
  }
};

export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  title,
  items,
  selectedItemText,
  onItemSelect,
  className = ''
}) => {
  const selectedText = selectedItemText || '';

  const handleItemClick = (itemText: string) => {
    onItemSelect?.(itemText);
  };

  return (
    <div style={styles.container} className={className}>
      <div style={styles.titleContainer}>
        <div style={styles.titleText}>
          {title}
        </div>
      </div>
      
      <div style={styles.itemsList}>
        {items.map((item) => (
          <div
            key={item.text}
            style={styles.menuItem}
            onClick={() => handleItemClick(item.text)}
          >
            <div style={selectedText === item.text ? styles.radioButtonSelected : styles.radioButton}>
              {selectedText === item.text && (
                <div style={styles.radioInner}></div>
              )}
            </div>
            <div style={styles.itemText}>
              {item.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
